import { Paper } from '@mui/material';
import { fromNullToUndefined, withDefault } from '@weft/utils';
import { Helmet } from 'react-helmet';
import { VyPageLayout } from '../../../components/new-design/layout/VyPageLayout';
import { withGlobalSearchParams } from '../../../components/utility/GlobalSearchParamsBoundary';
import { withSuspenseBoundary } from '../../../components/utility/SuspenseBoundary';
import { useProductsPage } from '../../../hooks/requests/pages/use-products-page';
import { usePageParam } from '../../../hooks/search-params/use-page-param';
import { usePageSizeParam } from '../../../hooks/search-params/use-page-size-param';
import { useSearchWithSearchParams } from '../../../hooks/use-search-with-search-params';
import { MetersTable } from './products-page-components/MetersTable/MetersTable';

const ProductsPage: React.FC = () => {
  const [query] = useSearchWithSearchParams();
  const [page] = usePageParam();
  const [pageSize] = usePageSizeParam();
  const { data: productsPageResponse, isLoading: isLoadingsProducts } = useProductsPage({
    search: fromNullToUndefined(query),
    page,
    pageSize,
  });

  const meters = withDefault(productsPageResponse?.meters, []);

  return (
    <div className="flex h-full w-full flex-col bg-[#F6F9FA]">
      <Helmet>
        <title>Products</title>
      </Helmet>
      
      <VyPageLayout
        path={['Products', 'Metered Products']}
        title="Metered Products"
      >
        <Paper sx={{
          height: '100%',
          overflow: 'hidden',
          position: 'relative',
          borderRadius: '10px',
        }}
        >
          <MetersTable
            items={meters}
            itemsCount={withDefault(productsPageResponse?.countedFilteredMeters, 0)}
            loadingItems={isLoadingsProducts}
          />
        </Paper>
      </VyPageLayout>
    </div>
  );
};

const ProductsPageWithSuspenseBoundary = withSuspenseBoundary(withGlobalSearchParams(ProductsPage));
export { ProductsPageWithSuspenseBoundary as ProductsPage };